<template>
  <form ref="chinapayForm" :action="chinapayUrl" class="chinapay-form" method="post">
    <input v-model="chinapayParam.AccessType" name="AccessType">
    <input v-model="chinapayParam.BusiType" name="BusiType">
    <input v-model="chinapayParam.TranType" name="TranType">
    <input v-model="chinapayParam.OrderAmt" name="OrderAmt">
    <input v-model="chinapayParam.TranDate" name="TranDate">
    <input v-model="chinapayParam.TranTime" name="TranTime">
    <input v-model="chinapayParam.Version" name="Version">
    <input v-model="chinapayParam.MerPageUrl" name="MerPageUrl">
    <input v-model="chinapayParam.MerOrderNo" name="MerOrderNo">
    <input v-model="chinapayParam.MerId" name="MerId">
    <input v-model="chinapayParam.MerBgUrl" name="MerBgUrl">
    <input v-model="chinapayParam.RemoteAddr" name="RemoteAddr">
    <!-- <input v-model="chinapayParam.TimeStamp" name="TimeStamp"> -->
    <input v-model="chinapayParam.Signature" name="Signature">
    <!--
    <input v-model="chinapayParam.InstuId" name="InstuId">
    <input v-model="chinapayParam.AcqCode" name="AcqCode">

    <input v-model="chinapayParam.CurryNo" name="CurryNo">
    <input v-model="chinapayParam.SplitType" name="SplitType">
    <input v-model="chinapayParam.SplitMethod" name="SplitMethod">
    <input v-model="chinapayParam.MerSplitMsg" name="MerSplitMsg">
    <input v-model="chinapayParam.BankInstNo" name="BankInstNo">
    <input v-model="chinapayParam.CommodityMsg" name="CommodityMsg">
    <input v-model="chinapayParam.MerResv" name="MerResv">
    <input v-model="chinapayParam.TranReserved" name="TranReserved">
    <input v-model="chinapayParam.CardTranData" name="CardTranData">
    <input v-model="chinapayParam.Term" name="Term">
    <input v-model="chinapayParam.PayTimeOut" name="PayTimeOut">
    <input v-model="chinapayParam.RiskData" name="RiskData"> -->
  </form>
</template>

<script>
export default {
  name: 'ChinapayForm',
  props: {
  },
  data() {
    return {
      chinapayUrl: 'https://newpaymenttest.chinapay.com/CTITS/service/rest/page/nref/000000000017/0/0/0/0/0 ',
      chinapayParam: {
        Version: '20140728',
        AccessType: '0',
        InstuId: '',
        AcqCode: '',
        MerId: '',
        MerOrderNo: '',
        TranDate: '',
        TranTime: '',
        OrderAmt: '',
        TranType: '',
        BusiType: '0001',
        CurryNo: 'CNY',
        SplitType: '',
        SplitMethod: '',
        MerSplitMsg: '',
        BankInstNo: '',
        MerPageUrl: '',
        MerBgUrl: '',
        CommodityMsg: '',
        MerResv: '',
        TranReserved: '',
        CardTranData: '',
        Term: '',
        PayTimeOut: '',
        TimeStamp: '',
        RemoteAddr: '',
        RiskData: '',
        Signature: ''
      }
    }
  },
  methods: {
    initForm(payUrl, payParams) {
      if(payUrl) {
        this.chinapayUrl = payUrl
      }
      if(payParams) {
        this.chinapayParam = Object.assign(this.chinapayParam, payParams)
      }
    },
    submitPay(payUrl, payParams) {
      this.initForm(payUrl, payParams)
      this.$nextTick(() => {
        this.$refs['chinapayForm'].submit()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.chinapay-form {
  display: none;
}
</style>
